/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPanelRight: {
  name: 'panel-right';
  data: string;
} = {
  name: 'panel-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm9 2H5v14h9V5Zm2 14V5h3v14h-3Z" fill="currentColor"/></svg>`,
};
